import moment from 'moment';

export const NAV_CONFIG = [
	{
		name: 'spend',
		label: 'Deep Dive',
		child: [
			{
				path: '/spend',
				name: 'spend',
				label: 'Investigate',
			},
			{
				path: '/spend/benchmarks',
				name: 'benchmarks',
				label: 'Benchmarks',
			},
			{
				path: '/spend/explore',
				name: 'transactions',
				label: 'Transactions',
			},
			{
				path: '/spend/pivot-table',
				name: 'pivot-table',
				label: 'Pivot Table',
			},
		],
	},
	{
		name: 'suplier-diversity-program',
		label: 'Supplier Diversity Program',
		path: '/spend/suplier-diversity-program', // include path key when you don't want to group navigation
		child: [
			{
				path: '/spend/suplier-diversity-program',
				name: 'suplier-diversity-program',
				label: 'Supplier Diversity Program',
			},
		],
	},
	{
		name: 'apvendor-library',
		label: 'AP Vendor Library',
		path: '/spend/apvendor-library',
		child: [
			{
				path: '/spend/apvendor-library',
				name: 'apvendor-library',
				label: 'AP Vendor Library',
			},
		],
	},
];

export const getUploadedTime = dateString => {
	const utcDate = new Date(dateString);
	const myLocalDate = new Date(
		Date.UTC(
			utcDate.getFullYear(),
			utcDate.getMonth(),
			utcDate.getDate(),
			utcDate.getHours(),
			utcDate.getMinutes()
		)
	);

	const today = moment();
	const momentDate = moment(myLocalDate);

	return momentDate.isSame(today, 'day')
		? `${momentDate.format('h:mma')} today`
		: `${momentDate.format('h:mma')} on ${momentDate.format('MMM D YYYY')}`;
};
